@if (isHowDoesItWork && !isPackageBenefits && isPremiumPackage) {
  <p class="font-weight-bold font-size-20 text-center pb-1">
    (
    <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE_TITLE' | translate"></span>
    )
  </p>
}
@if (isHowDoesItWork && !isPackageBenefits && isPremiumPlusPackage) {
  <p class="font-weight-bold font-size-20 text-center pb-1">
    (
    <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE_TITLE' | translate"></span>
    )
  </p>
}
@if (isHowDoesItWork && !isPackageBenefits && isStandardPackage) {
  <p class="font-weight-bold font-size-20 text-center pb-1">
    (
    <span [innerHTML]="'PACKAGE_SELECTION2.STANDARD_PACKAGE_TITLE' | translate"></span>
    )
  </p>
}
<div class="package_info_cont">
  @if (!isHowDoesItWork || isPackageBenefits) {
    <div class="package_price_cont">
      <div class="desc_wrap" [innerHTML]="descTooltip | translate"></div>
      <div class="package_price_wrap">
        <div class="package_price">
          <div class="price">
            <span class="cur">{{ currencySymbol }}</span>
            @if (isPremiumPackage) {
              <span class="lg_price">{{ numberFormatHelper.integer(premiumAmount) }}</span>
              <span class="sm_price">{{ numberFormatHelper.decimal(premiumAmount) }}</span>
            }
            @if (isPremiumPlusPackage) {
              <span class="lg_price">{{ numberFormatHelper.integer(premiumAmount) }}</span>
              <span class="sm_price">{{ numberFormatHelper.decimal(premiumAmount) }}</span>
            }
            @if (isStandardPackage) {
              <span class="lg_price">{{ numberFormatHelper.integer(standardAmount) }}</span>
              <span class="sm_price">{{ numberFormatHelper.decimal(standardAmount) }}</span>
            }
          </div>
          <div class="price_info" [innerHTML]="'PACKAGE_SELECTION2.STEUER.FOR_EVERY_STATEMENT' | translate"></div>
          @if (isPremiumPackage) {
            <div class="package_info_btn" [innerHTML]="'PACKAGE_SELECTION2.STEUER.PAY_LATER' | translate"></div>
          }
          @if (isPremiumPlusPackage) {
            <div class="package_info_btn" [innerHTML]="'PACKAGE_SELECTION2.STEUER.PAY_LATER' | translate"></div>
          }
        </div>
      </div>
      @if (isPremiumPackage) {
        <ul class="package_choise_list">
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_2' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_3' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_4' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_5' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_6' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_7' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span class="underline" [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_8' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_9' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
        </ul>
      }
      @if (isStandardPackage) {
        <ul class="package_choise_list">
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_2' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_3' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_4' | translate"></span>
            <img src="../../../assets/svg/true.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_5' | translate"></span>
            <img class="no" src="../../../assets/svg/false.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_6' | translate"></span>
            <img class="no" src="../../../assets/svg/false.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_7' | translate"></span>
            <img class="no" src="../../../assets/svg/false.svg" />
          </li>
          <li>
            <span class="underline" [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_8' | translate"></span>
            <img class="no" src="../../../assets/svg/false.svg" />
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.LIST.OPTION_9' | translate"></span>
            <img class="no" src="../../../assets/svg/false.svg" />
          </li>
        </ul>
      }
    </div>
  }
  @if (isHowDoesItWork && isPackageBenefits) {
    <hr class="how_does_it_work_divider" />
  }
  @if (isHowDoesItWork) {
    <div class="package_how_does_it_work text-center">
      @if (isPackageBenefits) {
        <p
          class="mb-2 font-weight-bold font-size-20"
          [innerHTML]="'PACKAGE_SELECTION2.HOW_DOES_IT_WORK' | translate"
        ></p>
      }
      @if (isPremiumPackage) {
        <ol>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_1' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_1.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_2' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_2.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_3' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_3.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_4' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/coins.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_5' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_4.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PACKAGE.OPTION_6' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_5.svg" />
            </div>
          </li>
        </ol>
      }
      @if (isPremiumPlusPackage) {
        <ol>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_1' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_1.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_2' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_2.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_3' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_3.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_4' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/coins.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_5' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_4.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.PREMIUM_PLUS_PACKAGE.OPTION_6' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_5.svg" />
            </div>
          </li>
        </ol>
      }
      @if (isStandardPackage) {
        <ol>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.STANDARD_PACKAGE.OPTION_1' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_1.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.STANDARD_PACKAGE.OPTION_2' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_5.svg" />
            </div>
            <div class="visible_lg">
              <img class="arrow_down" src="../../../assets/svg/arrow_down.svg" />
            </div>
          </li>
          <li>
            <span [innerHTML]="'PACKAGE_SELECTION2.STANDARD_PACKAGE.OPTION_3' | translate"></span>
            <div>
              <img class="tooltip_package" src="../../../assets/svg/package-selection/tooltip_package_2.svg" />
            </div>
          </li>
        </ol>
      }
    </div>
  }
  @if ((!isPremiumPackage || !isPremiumPlusPackage) && isHowDoesItWork && isPackageBenefits) {
    <hr class="how_does_it_work_divider" />
  }
  @if ((!isPremiumPackage || !isPremiumPlusPackage) && isHowDoesItWork && isPackageBenefits) {
    <div
      class="desc_wrap h-auto mb-2"
      [innerHTML]="'PACKAGE_SELECTION2.STANDARD.PRICING_DETAILS_FREE.DESCRIPTION' | translate"
    ></div>
  }
</div>
